import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

function CustomModal({
    show,
    onClose,
    title,
    message,
    messageHtml,
    actionLabel,
    onAction,
    closeVariant = 'secondary',
    closeLabel = 'Fermer',
    actionVariant = 'primary',
    actionClassName = '',
    closeClassName = '',
    onCloseButton
}) {
    const handleCloseButton = () => {
        if (onCloseButton) {
            onCloseButton();
        } else {
            onClose();
        }
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {messageHtml ? (
                    <div dangerouslySetInnerHTML={{ __html: messageHtml }} />
                ) : (
                    message
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant={closeVariant} onClick={handleCloseButton} className={closeClassName}>
                    {closeLabel}
                </Button>
                {onAction && (
                    <Button variant={actionVariant} onClick={onAction} className={actionClassName}>
                        {actionLabel}
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
}

export default CustomModal;
